import React, { PureComponent } from 'react';
import ReactDOMServer from 'react-dom/server';
import KeyHandler, { KEYDOWN } from 'react-key-handler';
import ReactInterval from 'react-interval';
import { withRouter } from 'react-router-dom';
import { withTimezone } from '@ro-utils/common/radar-params';
import { connect } from 'react-redux';
import { setRoImage } from '@ro-utils/common/map/radar';
import { getSliderProperties, format } from '@ro-utils/common/slider';
import { translate } from 'react-i18next';

import { getDayForSlider, getHour } from '@ro-sources/calendar';
import Pips, { PipsInner } from '@ro-atoms/Pips/';
import { RADAR_FORMAT } from '@ro-utils/constant';
import { RoSlider, RoSliderWrapper, RoSliderHandle, AnimationBanner } from '@ro-atoms/Slider/';
import RoSnack from '@ro-components/RoSnack';
import RoTooltip from '@ro-atoms/RoTooltip';

class SliderContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sliderValues: false,
      pipsStep: 4,
      scan: '',
      enabledAnimation: false,
      timeoutAnimation: props.userSettings.animationSpeed || 500
    };
    this.handleSliderUpdate = this.handleSliderUpdate.bind(this);
  }
  componentDidMount() {
    window.addEventListener('resize', e => {
      this.setPipes(e.target.innerWidth);
      setTimeout(() => {
        this.props.map.updateSize();
      });
    });
  }

  runAnimation = () => {
    const { sliderValues } = this.state;
    const start = Number(sliderValues[0]);
    const stop = Number(sliderValues[2]);
    const val = Number(sliderValues[1]);
    const newVal = val === stop ? start : val + 1;
    this.setState({
      sliderValues: [start, newVal, stop]
    });
  };

  componentWillReceiveProps(nextProps) {
    const { animation, userSettings } = this.props;
    nextProps.animation !== animation &&
      this.setState({
        enabledAnimation: nextProps.animation
      });
    nextProps.userSettings.animationSpeed !== userSettings.animationSpeed &&
      this.setState({
        timeoutAnimation: nextProps.userSettings.animationSpeed
      });
  }

  setPipes(vw) {
    this.setState({
      pipsStep: vw
    });
  }

  toDate(date, id) {
    const newDate = withTimezone(date, RADAR_FORMAT);
    const hour = `${getHour(newDate)}`;
    const day = `${getDayForSlider(newDate)}`;
    return {
      hour,
      day,
      id
    };
  }

  createTip({ hour, day, id }) {
    return ReactDOMServer.renderToStaticMarkup(<RoSliderHandle day={day} hour={hour} id={id} />);
  }

  setUiValueByKeyboard(e, value, method, check, sliderdata) {
    this.handleSliderUpdate(
      [parseFloat(value[0]), parseFloat(value[1]) + (check && method), parseFloat(value[2])],
      sliderdata
    );
  }

  setRadarValue(val, props) {
    return setRoImage(val, props);
  }

  handleSliderUpdate(values, sliderdata) {
    this.setState({
      sliderValues: values,
      scan: sliderdata[parseFloat(values[1])]
    });
  }

  render() {
    const {
      currentLocation,
      radarData,
      mapType,
      map,
      sliderVis,
      t,
      lightningsData,
      history,
      synopData,
      snowCoverData,
      userSettings,
      tutorialStarted
    } = this.props;

    const {
      sliderValues,
      //scan,
      timeoutAnimation,
      enabledAnimation
    } = this.state;

    const location = currentLocation;
    const slide = getSliderProperties(this.props, sliderValues);
    //const currentTime = slide.sliderdata.indexOf(scan);
    //const visibleSlide = currentTime !== -1 ? currentTime : slide.value[2];
    const val = slide && radarData[mapType][parseFloat(slide.value[1])];
    if (sliderVis && slide && slide.sliderdata && val) {
      this.setRadarValue(val, this.props);
    }

    return slide ? (
      <RoSliderWrapper tutorialStarted={tutorialStarted} tutorialLevel={userSettings.tutorialLevel}>
        <KeyHandler
          keyEventName={KEYDOWN}
          keyValue="ArrowLeft"
          onKeyHandle={e => this.setUiValueByKeyboard(e, slide.value, -1, slide.value[1] > slide.min, slide.sliderdata)}
        />
        <KeyHandler
          keyEventName={KEYDOWN}
          keyValue="ArrowRight"
          onKeyHandle={e =>
            this.setUiValueByKeyboard(e, slide.value, +1, slide.value[1] < slide.max - 1, slide.sliderdata)
          }
        />
        <ReactInterval {...{ timeout: timeoutAnimation, enabled: enabledAnimation, callback: this.runAnimation }} />
        {enabledAnimation && <AnimationBanner at={t(`time.at`)} time={this.toDate(this.state.scan)} />}
        {slide.sliderdata && sliderVis && (
          <RoSlider
            onUpdate={e => this.handleSliderUpdate(e, slide.sliderdata)}
            values={slide.value}
            type={mapType}
            radarData={radarData}
            length={slide.pip_length}
            options={{
              step: 1,
              range: { min: slide.min, max: slide.max - 1 },
              start: slide.value,
              animation: false,
              animate: false,
              tooltips: [
                format(slide.sliderdata, e => this.createTip(this.toDate(e, 0))),
                format(slide.sliderdata, e => this.createTip(this.toDate(e, 1))),
                format(slide.sliderdata, e => this.createTip(this.toDate(e, 2)))
              ]
            }}
          />
        )}
        <Pips
          width={window.innerWidth}
          length={slide.pip_length}
          lastItem={slide.sliderdata[slide.sliderdata.length - 1]}
        >
          {<PipsInner slide={slide} />}
        </Pips>
        <RoSnack>
          <RoTooltip
            mapType={mapType}
            text={location.label || location.hdms}
            label={location.label}
            currentLocation={userSettings.visibility.tooltip && currentLocation}
            lightningsData={lightningsData}
            history={history}
            synopData={synopData}
            scan={this.state.scan}
            snowCoverData={snowCoverData}
            map={map}
            // userSettings={userSettings}
            favoriteList={userSettings.favoriteLocations}
          />
        </RoSnack>
      </RoSliderWrapper>
    ) : null;
  }
}

const mapStateToProps = ({ ro }, { radarData }) => ({
  ...ro,
  radarData
});

export default withRouter(connect(mapStateToProps)(translate('common')(SliderContainer)));
